import React from 'react';
import ModalDimmed from '@components/common/modal/ModalDimmed';

type BottomModalProps = {
  children: React.ReactElement;
  onCloseBottomModal: React.MouseEventHandler<HTMLDivElement>;
};

export default function BottomModal({
  children,
  onCloseBottomModal,
}: BottomModalProps) {
  return (
    <div className="fixed z-20 top-[0] bottom-[0] left-[50%] translate-x-[-50%] w-full">
      <div className="absolute z-20 bottom-[0] w-full pt-[27px] px-[16px] surface_primary rounded-t-[24px]">
        {children}
      </div>
      <ModalDimmed onClose={onCloseBottomModal} />
    </div>
  );
}
